import React, { useEffect, useRef, useState } from 'react';
import Nav from './components/Nav.jsx';
import Hero from './components/Hero.jsx';
import Marquee from './components/Marquee.jsx';
import Pillars from './components/Pillars.jsx';
import ResearchIndex from './components/ResearchIndex.jsx';
import Engagements from './components/Engagements.jsx';
import OpenSource from './components/OpenSource.jsx';
import Publications from './components/Publications.jsx';
import People from './components/People.jsx';
import Cta from './components/Cta.jsx';
import Footer from './components/Footer.jsx';
import { GooDefs } from './components/loaders/index.js';

// Production defaults (Tweaks panel intentionally removed from production build).
// Wire to env vars / CMS if needed.
const TWEAKS = {
  heroTreatment: 'typographic',  // 'typographic' | 'mark' | 'metric'
  sectionDividers: 'numbered',   // 'numbered' | 'eyebrow' | 'plain'
  accent: 'clay',                // 'clay' | 'ochre' | 'sage'
  showCursorBlob: true,
  showGrain: true,
  showPeople: false,             // hidden pending partner name confirmation (F06)
};

export default function App() {
  useEffect(() => {
    const map = {
      clay:  { accent: '#C35A3A', deep: '#A64828', wash: '#F6E0D4' },
      ochre: { accent: '#C98B3A', deep: '#A06E22', wash: '#F4E6CC' },
      sage:  { accent: '#7B8A6F', deep: '#5C6B52', wash: '#DDE3D4' },
    };
    const c = map[TWEAKS.accent] || map.clay;
    document.documentElement.style.setProperty('--clay', c.accent);
    document.documentElement.style.setProperty('--clay-deep', c.deep);
    document.documentElement.style.setProperty('--clay-wash', c.wash);
    document.documentElement.style.setProperty('--accent', c.accent);
    document.documentElement.style.setProperty('--accent-hover', c.deep);
    document.documentElement.style.setProperty('--accent-wash', c.wash);
    document.documentElement.style.setProperty('--link', c.accent);

    document.body.style.backgroundImage = TWEAKS.showGrain ? 'url("/paper-grain.svg")' : 'none';
  }, []);

  return (
    <>
      <GooDefs />
      {TWEAKS.showCursorBlob && <CursorBlob />}
      <Nav tweaks={TWEAKS} />
      <main>
        <Hero tweaks={TWEAKS} />
        {/* Marquee hidden pending client-list sign-off (F07-engagements-permissions). */}
        {/* <Marquee tweaks={TWEAKS} /> */}
        <Pillars tweaks={TWEAKS} />
        <ResearchIndex tweaks={TWEAKS} />
        <Engagements tweaks={TWEAKS} />
        <OpenSource tweaks={TWEAKS} />
        <Publications tweaks={TWEAKS} />
        {TWEAKS.showPeople && <People tweaks={TWEAKS} />}
        <Cta tweaks={TWEAKS} />
      </main>
      <Footer tweaks={TWEAKS} />
    </>
  );
}

function CursorBlob() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let raf = 0;
    let tx = window.innerWidth / 2, ty = window.innerHeight / 2;
    let cx = tx, cy = ty;
    const move = (e) => { tx = e.clientX; ty = e.clientY; setVisible(true); };
    const leave = () => setVisible(false);
    const tick = () => {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      if (ref.current) {
        ref.current.style.left = cx + 'px';
        ref.current.style.top = cy + 'px';
      }
      raf = requestAnimationFrame(tick);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseleave', leave);
    raf = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('mousemove', move); window.removeEventListener('mouseleave', leave); };
  }, []);
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return null;
  return <div ref={ref} className="cursor-blob" style={{ opacity: visible ? 1 : 0 }} />;
}
